import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop — scrolls to the top of the page on route changes.
 *
 * LEGACY: slu-frontend/src/common/directives/sluScrollToTop.js
 *
 * The AngularJS directive watches a scope value and scrolls the element
 * to the top when it changes. This React equivalent uses useLocation
 * to detect route changes and scrolls the window to (0, 0).
 *
 * This is a render-null component that should be placed inside a Router.
 *
 * @example
 *   <HashRouter>
 *       <ScrollToTop />
 *       <AppRoutes />
 *   </HashRouter>
 */
export function ScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}
